import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import "../style/DashBoard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBillTransfer,
  faMoneyBillTrendUp,
  faMoneyCheckDollar,
} from "@fortawesome/free-solid-svg-icons";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import BalanceDetails from "./Components/BalanceList";
import "@demark-pro/react-booking-calendar/dist/react-booking-calendar.css";
import { faMoneyCheck } from "@fortawesome/free-solid-svg-icons/faMoneyCheck";
import Loading from "./Loading";

export default function DashBoard() {
  const location = useLocation();
  const passedState = location.state;

  const [totalProfit, setTotalProfit] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [growthData, setGrowthData] = useState([]);
  const [Bookings, setBookings] = useState([]);
  const [Incomes, setIncomes] = useState([]);
  const [Expense, setExpense] = useState([]);
  const [Profit, setProfit] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [totalCapital, setTotalCapital] = useState(0);
  const [capitalBalance, SetCapitalBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [rights, setRights] = useState("");
  const [loadPage, setLoadPage] = useState(true);

  const [currentForm, setCurrentForm] = useState("totalIncome");
  const [isActive, setIsActive] = useState(0);

  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const renderChart = () => {
    switch (currentForm) {
      case "totalIncome":
        return (
          <>
            <p style={{ margin: "0 ", textAlign: "center", padding: "5px 0" }}>
              Total Income
            </p>
            <TotalIncomeChart data={Incomes} />
          </>
        );
      case "totalExpense":
        return (
          <>
            <p style={{ margin: "0 ", textAlign: "center", padding: "5px 0" }}>
              Total Expense
            </p>
            <TotalExpenseChart data={Expense} />
          </>
        );
      case "totalProfit":
        return (
          <>
            <p style={{ margin: "0 ", textAlign: "center", padding: "5px 0" }}>
              Total Profit
            </p>
            <TotalProfitChart data={Profit} />
          </>
        );
       
      default:
        return null;
    }
  };
  const TripBookingChart = ({ data }) => {
    const [activeMonth, setActiveMonth] = useState(null);

    const handleMouseEnter = (data) => {
      setActiveMonth(data);
    };

    const handleMouseLeave = () => {
      setActiveMonth(null);
    };

    const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        const { month, value, bookings } = payload[0].payload;
        return (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2px",
              border: "1px solid #ccc",
            }}
          >
            <h4>{month + "(" + value + " Bookings )"}</h4>
            <ul>
              {bookings.map((booking, index) => (
                <li key={index}>{booking}</li>
              ))}
            </ul>
          </div>
        );
      }
      return null;
    };

    return (
      <ResponsiveContainer width="95%" height={310}>
        <BarChart data={data} layout="vertical">
          <XAxis type="number" domain={[0, 20]} />
          <YAxis dataKey="month" type="category" />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            fill="#8884d8"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const TotalIncomeChart = ({ data }) => {
    const [activeMonth, setActiveMonth] = useState(null);

    const handleMouseEnter = (data) => {
      setActiveMonth(data);
    };

    const handleMouseLeave = () => {
      setActiveMonth(null);
    };

    const CustomTooltip = ({ active, payload }) => {
      
      if (active && payload && payload.length) {
        const { month, value, bookings } = payload[0].payload;
        console.log(month,value,bookings)
        return (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2px",
              border: "1px solid #ccc",
            }}
          >
            <h4>{month + "(Income - ₹" + value + ")"}</h4>
            {bookings.map((booking, index) => (
              <li key={index}>{booking}</li>
            ))}
          </div>
        );
      }
      return null;
    };

    return (
      <ResponsiveContainer width="95%" height={310}>
        <BarChart data={data} layout="vertical">
          <XAxis type="number" domain={[0, 100000]} />
          <YAxis dataKey="month" type="category" />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            fill="#8884d8"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const TotalExpenseChart = ({ data }) => {
    const [activeMonth, setActiveMonth] = useState(null);

    const handleMouseEnter = (data) => {
      setActiveMonth(data);
    };

    const handleMouseLeave = () => {
      setActiveMonth(null);
    };

    const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        const { month, value } = payload[0].payload;
        return (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2px",
              border: "1px solid #ccc",
            }}
          >
            <h4>{month + "(Expense - ₹" + value + ")"}</h4>
          </div>
        );
      }
      return null;
    };

    return (
      <ResponsiveContainer width="95%" height={310}>
        <BarChart data={data} layout="vertical">
          <XAxis type="number" domain={[0, 100000]} />
          <YAxis dataKey="month" type="category" />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            fill="#8884d8"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const TotalProfitChart = ({ data }) => {
    const [activeMonth, setActiveMonth] = useState(null);

    const handleMouseEnter = (data) => {
      setActiveMonth(data);
    };

    const handleMouseLeave = () => {
      setActiveMonth(null);
    };

    const CustomTooltip = ({ active, payload }) => {
      if (active && payload && payload.length) {
        const { month, value } = payload[0].payload;
        return (
          <div
            style={{
              backgroundColor: "#fff",
              padding: "2px",
              border: "1px solid #ccc",
            }}
          >
            <h4>{month + "(Profit - ₹" + value + ")"}</h4>
          </div>
        );
      }
      return null;
    };

    return (
      <ResponsiveContainer width="95%" height={310}>
        <BarChart data={data} layout="vertical">
          <XAxis type="number" domain={[0, 100000]} />
          <YAxis dataKey="month" type="category" />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="value"
            fill="#8884d8"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  useEffect(() => {
    const fetchAllDetails = async () => {
      console.log('fetchAllDetails')
      await axios
        .get(
          `${process.env.REACT_APP_API_BASE_URL}/dashboard/details`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          },
          { withCredentials: true }
        )
        .then((response) => {
          console.log(response.data)
          setGrowthData(response.data.growth);
          setTotalProfit(response.data.profit);
          setTotalExpense(Number(response.data.totalExpense));
          setTotalIncome(Number(response.data.totalIncome));
          setTotalBalance(response.data.totalBalance);
          setBookings(response.data.bookings);
          setIncomes(response.data.incomes);
          setExpense(response.data.expenses);
          setProfit(response.data.profits);
          SetCapitalBalance(response.data.capitalBalance);
          setTotalCapital(response.data.totalCapital);
          setUsername(sessionStorage.getItem("username"));
          setRights(sessionStorage.getItem("rights"));
          setLoadPage(false);
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    };
    fetchAllDetails();
  }, [loadPage]);

  return loadPage ? (
    <Loading />
  ) : (
    <div>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>
      <div className="Dashboard">
        <Menu username={username} rights={rights}></Menu>
        <div className="DashboardApp">
          <div className="DashBoardTop">
            <div
              className={"Dashboardcard"}
              style={{
                background: "linear-gradient(to right, #337449FF, #014C36FF)",
              }}
            >
              <div className="CardInfo">
                <h4> Capital</h4>
                
                <h3>₹ {(Number(totalCapital) - Number(capitalBalance)) || 0}</h3>
              </div>
              <FontAwesomeIcon
                className="CardIcon"
                icon={faMoneyCheckDollar}
              ></FontAwesomeIcon>
            </div>
            <div
              className={
                isActive === 0 ? "Dashboardcard DActive" : "Dashboardcard"
              }
              onClick={() => {
                setIsActive(0);
                setCurrentForm("totalIncome");
              }}
              style={{
                background: "linear-gradient(90deg, #FFE070 0%, #FE995F 100%)",
              }}
            >
              <div className="CardInfo">
                <h4>Total Income</h4>
                <h3>₹ {Number(totalIncome)}</h3>
              </div>
              <FontAwesomeIcon
                className="CardIcon"
                icon={faMoneyBillTrendUp}
              ></FontAwesomeIcon>
            </div>
            <div
              className={
                isActive === 1 ? "Dashboardcard DActive" : "Dashboardcard"
              }
              onClick={() => {
                setIsActive(1);
                setCurrentForm("totalExpense");
              }}
              style={{
                background: "linear-gradient(to right, #56ccf2, #2f80ed)",
              }}
            >
              <div className="CardInfo">
                <h4> Expense</h4>
                <h3>₹ {Number(totalExpense)}</h3>
              </div>
              <FontAwesomeIcon
                className="CardIcon"
                icon={faMoneyBillTransfer}
              ></FontAwesomeIcon>
            </div>

            {/* profit */}
            <div
              className={
                isActive === 2 ? "Dashboardcard DActive" : "Dashboardcard"
              }
              onClick={() => {
                setIsActive(2);
                setCurrentForm("totalProfit");
              }}
              style={
                totalProfit >= 0
                  ? {
                      background: "linear-gradient(to right, #2591A6, #6DD8B8)",
                    }
                  : {
                      background:
                        "linear-gradient(to right, #D9737C, #99301E) ",
                    }
              }
            >
              <div className="CardInfo">
                <h4> Profit</h4>
                <h3>₹ {totalProfit !== null ? Number(totalProfit) : 0}</h3>
              </div>
            </div>
            {/* <div
              className="Dashboardcard "
              style={
                totalProfit >= 0
                  ? {
                      background: "linear-gradient(to right, #2591A6, #6DD8B8)",
                    }
                  : {
                      background:
                        "linear-gradient(to right, #D9737C, #99301E) ",
                    }
              }
            >
              <div className="CardInfo">
                <h4>Profit</h4>
                <h3>₹ {totalProfit !== null ? Number(totalProfit) : 0}</h3>
              </div>
            </div> */}
            <div
              className={"Dashboardcard"}
              style={{
                background:
                  "linear-gradient(-225deg, #5D9FFF 0%, #B8DCFF 48%, #6BBBFF 100%)",
              }}
            >
              <div className="CardInfo">
                <h4>Pending Amount</h4>
                <h3>₹ {Number(totalBalance)}</h3>
              </div>
              <FontAwesomeIcon
                className="CardIcon"
                icon={faMoneyCheck}
              ></FontAwesomeIcon>
            </div>
          </div>
          <div className="DetailsBoxes">
            <div className="DetailsBox">{renderChart()}</div>
            <div className="DetailsBox1">
              <BalanceDetails />
            </div>
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
}

//linear-gradient(to right, #56ccf2, #2f80ed)
//linear-gradient(to right, #007991, #78ffd6)
//linear-gradient(to right, #d66d75, #e29587)
//linear-gradient(90deg, #FAD961 0%, #F76B1C 100%)

//#6CB4EE
//background-image: linear-gradient(-225deg, #5D9FFF 0%, #B8DCFF 48%, #6BBBFF 100%);
/*
<div className='DetailsBox'>
              <p style={{margin:"0 ",textAlign:"center",padding:"5px 0"}}>Trip Bookings</p>
            <TripBookingChart data={Bookings} />
            </div>



            <br></br><br></br><br></br>
            <Calendar color='red'
      reserved={reservedDates}
    />
    <div className="DashboardMiddle" style={{ marginTop: "20px", backgroundColor: "#fff", padding: "20px", borderRadius: "10px" }}>
              <h3>Total Growth</h3>
              <Bar data={data} />
            </div>
*/
